import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { Grid } from '@mui/material';
import { getSubVendor, patchUpdateSubVendor, postAddSubVendor } from 'redux/actions/UserSubVendor';
import CommonTable from 'components/commonTable/CommonTable';
import CommonButtonHeader from 'components/commonButtonHeader/commonButtonHeader';
import { filterStatusData, subVendorDialogData } from 'pages/vendor/VendorBreadCrumbData';
import CommonDialog from 'components/commonDialog/CommonDialog';
import Loader from 'components/loader/Loader';
import { dateFormate } from 'utils/utils';



function TableSubVendor() {
  let singleSubStatus = JSON.parse(localStorage.getItem('singleSubStatus'))
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {state} = useLocation() || {};
  const tableData = useSelector((state) => state?.userSubVendor?.userSubVendor?.data);
  const loader = useSelector((state) => state?.userSubVendor?.loading);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [status, setStatus] = useState(state?.subVendorStatus ? state?.subVendorStatus : singleSubStatus?.length > 0 ? singleSubStatus : "");
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('Edit');
  const [id, setId] = useState(null);
  const [defaultValue, setDefaultValue] = useState({})
  const ID = localStorage.getItem('ID')
  const companyId = localStorage.getItem('companyId')
  const companyName = localStorage.getItem('companyName')
  const role = localStorage.getItem('role')
  const [search, setSearch] = useState("")
  let filterData = {
    id: state?.companyType === 'adminCompany' ? '' : companyId,
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    pageSize: rowsPerPage,
    search:search
  }
  const defaultSubVendor = {
    name:companyName,
  };

  useEffect(() => {
    dispatch(getSubVendor(filterData));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    dispatch(getSubVendor({ ...filterData, page: newPage }))
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getSubVendor({ ...filterData, page: 0, pageSize: parseInt(event.target.value) }))
  }

  const onFilterChange = (val) => {
    localStorage.removeItem('singleSubStatus')
    setPage(0);
    setStatus(val)
    filterData = { ...filterData, status: val.toString(), page: 0 }
    dispatch(getSubVendor(filterData));
  }

  const onRestFilter = () => {
    localStorage.removeItem('singleSubStatus')
    setStatus("")
    filterData = { ...filterData, status: "" }
    dispatch(getSubVendor(filterData));
  }

  const onSelectDateRange = (newValue) => {
    setDateFrom(dateFormate(newValue[0], "MM/DD/YYYY"))
    setDateTo(dateFormate(newValue[1], "MM/DD/YYYY"))
    filterData = {
      ...filterData,
      dateFrom: dateFormate(newValue[0], "MM/DD/YYYY"),
      dateTo: dateFormate(newValue[1], "MM/DD/YYYY")
    }
    dispatch(getSubVendor(filterData));
  }

  const onClickTableSubVendor = (val) => {
    localStorage.setItem('singleSubStatus', JSON.stringify(status))
    navigate(
      '/subvendor/details', {state: {subVendorId:val?.id, status:val?.status, name:val?.name, companyId:val?.companyId, companyName: val?.companyName}}
    );
  }

  const onSubmit = (val, code) => {
    const data = {
      mobile: val.number,
      firstName: '',
      lastName: '',
      email: val.email,
      countryCode: code,
      vendorId: companyId,
      companyName: val.vendorName,
    }
    dispatch(postAddSubVendor(data))
  }

  const onClickMoreIcon = (data, type) => {
    const value = {
      vendorName: data?.companyName.trim(),
      email: data?.email,
      number: data?.mobile,
      address: data?.address,
      city: data?.city,
      state: data?.state,
      name:data?.vendorName
    }
    setDefaultValue(value)
    setId(data.id)
    if (type === 'Delete') {

    } else if (type === 'Edit') {
      setType(type)
      setOpen(true);
    } else if (type === 'Deactivate') {
      const profileData = {
        subVendorId: data.id,
        data: {
          status: 'InActive'
        }
      }
      dispatch(patchUpdateSubVendor({...profileData, id:companyId}));
    } else if (type === 'Activate') {
      const profileData = {
        subVendorId: data.id,
        data: {
          status: 'Active'
        }
      }
      dispatch(patchUpdateSubVendor({...profileData, id:companyId}));
    } else if (type === 'Block') {
      const profileData = {
        subVendorId: data.id,
        data: {
          status: 'Blocked'
        }
      }
      dispatch(patchUpdateSubVendor({...profileData, id:companyId}));
    }else if (type === 'Unblock') {
      const profileData = {
        subVendorId: data.id,
        data: {
          status: 'Active'
        }
      }
      dispatch(patchUpdateSubVendor({...profileData, id:companyId}));
    }

  }

  const onDialog = (val, code) => {
    const profileData = {
      subVendorId: id,
      data: {
        firstName: val?.companyName,
        lastName: '',
        email: val?.email,
        countryCode: '+91',
        mobile: val?.number,
        companyName: val?.vendorName,
        location: val?.address,
      },
    };
    dispatch(patchUpdateSubVendor(profileData));
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  }
  const onSearch = debounce((e) =>{
    setSearch(e);
    setPage(0);
   const searchFilterData = {
    ...filterData,search:e, page:0
   }
   dispatch(getSubVendor(searchFilterData))
  },1000)

  return (
    <div>
      <Grid container direction='row' justifyContent='space-between' alignItems='center'>
        <CommonButtonHeader
          defaultStatus={status}
          buttonFilterdata={filterStatusData}
          buttontitle={'Sub-Vendor '}
          buttonFormData={subVendorDialogData}
          onSubmittBtn={onSubmit}
          onSelectDateRange={onSelectDateRange}
          onFilterChange={onFilterChange}
          onRestFilter={onRestFilter}
          onSearch={onSearch}
          companyType={state?.companyType ? state?.companyType : ''}
          defaultValues={role === 'vendorCompany' ? defaultSubVendor : {}}
        />
      </Grid>
      {loader ?
        <Loader />
        :
        <CommonTable
          data={tableData}
          onClickTableVendor={onClickTableSubVendor}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          onClickMoreIcon={onClickMoreIcon}
          isClickable = {true}
        />
      }

      {open ? <CommonDialog
        open={open}
        handleClose={handleClose}
        formData={subVendorDialogData}
        button={'dialogButton'}
        onSubmittBtn={onDialog}
        type={'Edit ' + 'Sub-Vendor' + " "}
        selectType={'edit'}
        defaultValues={defaultValue}
      /> : null}
    </div>
  );
}

export default TableSubVendor;
